Shopify.personalisation = function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', Shopify.personalisation);
    return;
  }

  if (window._personalisationInit) return;
  window._personalisationInit = true;

  const elements = {
    customizationProduct: document.querySelector('.customization_product'),
    paymentButton: document.querySelector('[data-shopify="payment-button"]'),
    addToCartButton: document.querySelector('.add-to-cart[type="submit"]'),
    propertiesInputs: document.querySelectorAll('.properties_custom input'),
    checkedRadio: document.querySelector('.btn-radio__checked:checked'),
    engraving: document.querySelector('[data-option-name="Engraving"] [type="radio"]:checked')
  };

  if (!elements.customizationProduct && elements.paymentButton) {
    elements.paymentButton.remove();
  }

  const updateButtonState = (disabled, reason = '') => {
    const button = elements.addToCartButton || document.querySelector('.add-to-cart[type="submit"]');
    if (button) {
      button.disabled = disabled;
      button.dataset.disableReason = reason;
    }
  };

  const handleChecked = (el) => {
    if (!el) return;

    const isNoOption = el.value === "no";
    const parent = el.closest(".product_properties");
    const layoutInput = el.closest(".layoutInput");

    if (!parent || !layoutInput) return;

    const errorElement = parent.querySelector(".properties_custom__error");
    const noCustomInput = layoutInput.querySelector(".noCustom");
    const propertiesInputs = layoutInput.querySelectorAll(".properties_custom input");
    const propertiesDiv = layoutInput.querySelector(".properties_custom");

    if (errorElement) errorElement.style.display = "none";

    if (isNoOption) {
      if (noCustomInput) {
        noCustomInput.value = "Customer requires no text";
        noCustomInput.removeAttribute("disabled");
      }
      propertiesInputs.forEach(input => {
        if (input) {
          input.setAttribute("disabled", "disabled");
          input.style.display = "none";
        }
      });
      if (propertiesDiv) propertiesDiv.style.display = "none";
      updateButtonState(false, 'no-customization');
      return;
    }

    if (noCustomInput) {
      noCustomInput.setAttribute("disabled", "disabled");
      noCustomInput.value = "";
    }
    propertiesInputs.forEach(input => {
      if (input) {
        input.removeAttribute("disabled");
        input.style.display = "block";
      }
    });
    if (propertiesDiv) propertiesDiv.style.display = "block";
    updateButtonState(true, 'customization-required');
  };

  const validateInput = (input) => {
    const value = input.value ? input.value.trim() : '';
    const parent = input.closest(".product_properties");
    if (!parent) return;

    const errorElement = parent.querySelector(".properties_custom__error");
    const isEmpty = value === "";

    if (errorElement) errorElement.style.display = isEmpty ? "block" : "none";
    input.style.border = isEmpty ? "1px solid red" : "";
    input.style.borderColor = isEmpty ? "" : "#e3e3e3";
    updateButtonState(isEmpty, isEmpty ? 'input-validation' : 'input-valid');
  };

  const updateAddToCartState = (radioButton) => {
    if (!radioButton) return;
    updateButtonState(
      radioButton.value.toLowerCase() === 'yes',
      radioButton.value.toLowerCase() === 'yes' ? 'engraving-yes' : 'engraving-no'
    );
  };

  elements.propertiesInputs.forEach(input => {
    input.addEventListener("keyup", () => validateInput(input));
  });

  if (elements.checkedRadio && elements.checkedRadio.value === "no") {
    handleChecked(elements.checkedRadio);
  }

  updateAddToCartState(elements.engraving);

  document.addEventListener("change", (event) => {
    const target = event.target;
    if (target.matches('[data-option-name="Engraving"] [type="radio"]')) {
      updateAddToCartState(target);
    }
    if (target.classList.contains("btn-radio__checked")) {
      handleChecked(target);
    }
  });
};

Shopify.checkInputEmpty = function() {
  const context = document.querySelector('.sf-modal__wrapper') ? '.sf-modal__wrapper' : '';
  const checkedRadios = document.querySelectorAll(context + ' .btn-radio__checked:checked');

  for (const radio of checkedRadios) {
    if (radio.value === "yes") {
      const layoutInput = radio.closest('.layoutInput');
      const customInput = layoutInput?.querySelector('.properties_custom input');
      if (customInput && customInput.value.trim() === "") {
        const button = document.querySelector(context + ' .add-to-cart[type="submit"]');
        if (button) button.disabled = true;
        break;
      }
    }
  }
};

;(function() {
  let retryCount = 0;
  const maxRetries = 10;

  const initPersonalisation = () => {
    if (typeof Shopify?.personalisation === 'function') {
      try {
        window._personalisationInit = false;
        Shopify.personalisation();
      } catch (e) {
        console.warn('Personalisation init failed:', e);
      }
    } else if (retryCount < maxRetries) {
      retryCount++;
      setTimeout(initPersonalisation, 100);
    }
  };

  const setupQuickview = () => {
    if (window.MinimogTheme?.ProductQuickView?.modal) {
      const originalOpen = window.MinimogTheme.ProductQuickView.modal.open;
      window.MinimogTheme.ProductQuickView.modal.open = function() {
        originalOpen.call(this);
        setTimeout(() => {
          retryCount = 0;
          initPersonalisation();
        }, 150);
      };
    } else {
      setTimeout(setupQuickview, 500);
    }
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('.sf-pqv__button')) {
      retryCount = 0;
      setTimeout(initPersonalisation, 400);
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 &&
            (node.classList?.contains('sf-modal__wrapper') ||
             node.querySelector?.('.sf-modal__wrapper'))) {
          setTimeout(() => {
            retryCount = 0;
            initPersonalisation();
          }, 200);
        }
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupQuickview();
      if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    setupQuickview();
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', Shopify.personalisation);
} else {
  Shopify.personalisation();
}